import React, { useEffect, useState } from "react"
import style from "./modalCalendar.module.scss"
import Modal from "../Modal/Modal"
import SelectDateRangeButton from "./selectDateRangeButton/selectDateRangeButton"
import CalenderComponent from "./calenderComponent/calenderComponent"
import Button from "../Button/button"
import momentJalaali from 'moment-jalaali';
import toPersianNumber from "../../helpers/actions/toPersianNumber"

const dateRangeNames = ['امروز', 'دیروز', 'هفته اخیر', 'هفته قبل', 'ماه اخیر', 'ماه قبل']
const CalendarModal = (props) => {
    const [openCalendar, setOpenCalendar] = useState(false)
    const [selectedDefaultRange, setSelectedDefaultRange] = useState(props.label ? props.label : 'هفته اخیر')
    const [range, setRange] = useState({})

    //lifeCycles***********************************************
    useEffect(() => {
        if (props.value) {
            let label = ''
            dateRangeNames.forEach((item) => {
                let temp = getDefaultRange(item)
                if (momentJalaali(temp.start).startOf('day').unix() === momentJalaali(props.value.start).startOf('day').unix() && momentJalaali(temp.end).startOf('day').unix() === momentJalaali(props.value.end).startOf('day').unix()) {
                    label = item
                }
            })
            if (label) {
                props.dateLabel(label)
            } else {
                let temp = momentJalaali(props.value.end).format('jYYYY/jM/jD') + " - " + momentJalaali(props.value.start).format('jYYYY/jM/jD')
                props.dateLabel(toPersianNumber(temp))
            }

        } else {
            props.dateLabel('انتخاب بازه‌ی زمانی')
        }
    }, [props.value])

    useEffect(() => {
        setOpenCalendar(props.openModal)
    }, [props.openModal])
    //functions************************************************
    const closeModalFunction = () => {
        setOpenCalendar(false);
    }

    const getDefaultRange = (key) => {
        switch (key) {
            case "امروز":
                return {
                    start: momentJalaali(),
                    end: momentJalaali()
                }
            case "دیروز":
                return {
                    start: momentJalaali().subtract(1, "day"),
                    end: momentJalaali().subtract(1, "day"),
                }

            case "هفته اخیر":
                return {
                    start: momentJalaali().subtract(7, "day"),
                    end: momentJalaali(),
                }
            case "هفته قبل":
                return {
                    start: momentJalaali().subtract(14, "day"),
                    end: momentJalaali().subtract(7, "day"),
                }
            case "ماه اخیر":
                return {
                    start: momentJalaali().subtract(30, "day"),
                    end: momentJalaali(),
                }

            case "ماه قبل":
                return {
                    start: momentJalaali().subtract(60, "day"),
                    end: momentJalaali().subtract(30, "day")

                }
        }
    }
    //handlers**************************************************
    const setDefaultRange = (defaultRange) => {
        setSelectedDefaultRange(defaultRange)
        props.dateLabel(selectedDefaultRange)
    }
    const setDateRange = (range) => {
        setRange(range);
    }
    const confirmDateRange = () => {
        if (range && range.start && range.end) {
            let temp = momentJalaali(range.end).format('jYYYY/jM/jD') + " - " + momentJalaali(range.start).format('jYYYY/jM/jD')
            !range.defaultValue ? props.dateLabel(toPersianNumber(temp)) : props.dateLabel(selectedDefaultRange)
            props.setRange(range)
            closeModalFunction()
        }

    }
    return (
        <React.Fragment>
            <div className={style.wrapper}>
                <button
                    className={props.label != 'انتخاب بازه‌ی زمانی' ? style.selectedDate : style.noDateSelected}
                    onClick={() => setOpenCalendar(!openCalendar)}
                >
                    <div className={style.icon}></div>
                    <div className={style.label}>{props.label}</div>
                </button>
                <div className={style.modalWrapper}>
                    <Modal
                        tag=''
                        title='انتخاب تاریخ'
                        value={openCalendar}
                        parentClose={closeModalFunction}
                    >
                        <div className={style.modalContent}>
                            <div className={style.row}>
                                {dateRangeNames.map((item, index) => {
                                    return <div className={style.buttonWrapper} key={index}>
                                        <SelectDateRangeButton label={item}
                                            active={selectedDefaultRange === item ? true : false}
                                            onclick={setDefaultRange} />
                                    </div>
                                })}
                            </div>
                            <div className={style.caledarWrapper}>
                                <CalenderComponent
                                    defaultValues={selectedDefaultRange ? selectedDefaultRange : 'هفته اخیر'}
                                    exportRange={setDateRange}
                                    value={props.value ? props.value : { start: momentJalaali().subtract(30, "day"), end: momentJalaali() }}
                                />
                            </div>
                            <div className={style.buttonWrapper}>
                                <div className={style.box}>
                                    <Button label="تایید" type="solid" onclick={confirmDateRange} />
                                </div>
                                <div className={style.box}>
                                    <Button label="انصراف" type="outline" onclick={closeModalFunction} />
                                </div>
                            </div>
                        </div>
                    </Modal>

                </div>
            </div>
        </React.Fragment>
    );
}

export default CalendarModal;

/*
*
tag='برند'                              :Label is the text above dropdown and its OPTIONAL
placeHolder='برن                            :The tag that will be returned everytime a function inside the component is called(REQUIRED)
label='برند'  د'               :Placeholder is the text inside dropdown button and is REQUIRED
dropdownList={array}                    :dropdownList is the items you wish to see when dropdown is clicked( also REQUIRED )
hasSearchBox={true}                     :You can define wether you want to have a search box or not
hasCheckbox={false}                     :Enables you to choose between single-select/multi-select modes
handleSelect={handleSelect}             :HandleSelect must be defined in parent component and will be given "tag" and "value" as function's parameters(REQUIRED)
handleSearch={handleSearch}             :HandleSearch is also defined in parent component and will be given "tag" and "value" as function's parameters
deleteSelectedItems={deleteAll}         :In case you want to delete all the selected values and it must be defined in parent(REQUIRED)
*
 */
